export class BaseDTO {
  public id: string | undefined;
}

export class BaseNameDTO extends BaseDTO {
  public name: string | undefined;
}
